import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
//i18n
import { withTranslation } from "react-i18next";

// default small logo
import logoSm from "../../assets/images/logo-sm.png";
// default light/dark logos
import logoLight from "../../assets/images/optimize_logo light.png";
import logoDark from "../../assets/images/optimize_logo dark.png";
import aptivDark from "../../assets/images/aptiv.jpg";
import aptivLIght from "../../assets/images/aptive1.png";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";

const Header = (props) => {
  const [search, setsearch] = useState(false);
const companyId= localStorage.getItem("companyid");
  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }
   const authToken = localStorage.getItem("access");
   const role =localStorage.getItem("role");
  //const authToken = JSON.parse(localStorage.getItem("authUser")).token;
  const [selectedCompanyLogo, setSelectedCompanyLogo] = useState({ light: "", dark: "" });


useEffect(() => {
  async function fetchCompanyLogos() {
    try {
      const companyId = localStorage.getItem("companyid");

      const response = await fetch(`https://api.hanoch.in/api/company-logo-getbyid/?company_id=${companyId}`);
      const data = await response.json();

      if (data?.logos?.length >= 2) {
        // Save to localStorage
        localStorage.setItem("company_logo_light", data.logos[0]);
        localStorage.setItem("company_logo_dark", data.logos[1]);

        // Save to state
        setSelectedCompanyLogo({
          light: data.logos[0],
          dark: data.logos[1],
        });
      }
    } catch (error) {
      console.error("Error fetching company logo:", error);
    }
  }

  fetchCompanyLogos();
}, []);
useEffect(() => {
  const light = localStorage.getItem("company_logo_light");
  const dark = localStorage.getItem("company_logo_dark");
console.log("logo",light,dark)
  if (light && dark) {
    setSelectedCompanyLogo({ light, dark });
  }
}, []);

 
  return (
    <React.Fragment>
      <header id="page-topbar" className="pb-2 pt-1">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <div className="py-2 px-1">
              <button
              type="button"
              className="btn btn-sm py-3 font-size-24 header-item waves-effect"
              id="vertical-menu-btn"
              onClick={() => {
                tToggle();
              }}
            >
              <i className="ri-menu-2-line align-middle"></i>
            </button>
            </div>
            <div
              className="navbar p-0 justify-content-center "
              // style={{ background: "white" }}
            >
               <Link to="/" className="logo logo-dark">
                <span className="logo-lg">
                  <img src={`https://api.hanoch.in/${selectedCompanyLogo.light || logoDark}`} alt="logo-dark" height="72" />
                </span>
                <span className="logo-sm">
                  <img src={`https://api.hanoch.in/${selectedCompanyLogo.light || logoDark}`} alt="logo-sm-dark" height="72" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={`https://api.hanoch.in/${selectedCompanyLogo.dark || logoLight}`} alt="logo-sm-light" height="72" />
                </span>
                <span className="logo-lg">
                  <img src={`https://api.hanoch.in/${selectedCompanyLogo.dark || logoLight}`} alt="logo-light" height="72" />
                </span>
              </Link>  
              {/* <span className="logo-sm">
  <img
 
    src={`https://api.hanoch.in/${selectedCompanyLogo.light || logoSm}`}
    alt="company-light"
    height="72"
  />
</span> */}

{/* <span className="logo-lg">
  <img
    src={`https://api.hanoch.in/${selectedCompanyLogo.dark || logoDark}`}
    alt="company-dark"
    height="72"
  />
</span> */}

            </div>

          

           
          </div>

          <div className="d-flex">
            {/* {selectedCompanyLogo && ( */}
            {/* {role !=="demo" && (
              <>
                <img
                  className="btn header-item noti-icon"
                  src={aptivDark}
                  height="55"
                  style={{ borderRadius: "20px" }}
                  alt=""
                />
              </>
             )}  */}
          </div>
          <div className="d-flex">
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="ri-fullscreen-line" />
              </button>
            </div>

            <ProfileMenu />
{companyId != 5 && (
            <div
              className="dropdown d-inline-block"
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle waves-effect"
              >
                <i className="mdi mdi-cog"></i>
              </button>
            </div>
)}
          </div>
          
        </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
